import odata from 'odata-client';
import {
  DELETE_PROJECT_OFFER_DOCUMENT_REQUEST,
  DELETE_PROJECT_OFFER_DOCUMENT_ERROR,
  DELETE_PROJECT_OFFER_DOCUMENT_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const deleteProjectOfferDocumentRequest = () => ({
  type: DELETE_PROJECT_OFFER_DOCUMENT_REQUEST
});

export const deleteProjectOfferDocumentError = errorOrResult => ({
  type: DELETE_PROJECT_OFFER_DOCUMENT_ERROR,
  error: errorOrResult.message
});

export const deleteProjectOfferDocumentSuccess = payload => ({
  type: DELETE_PROJECT_OFFER_DOCUMENT_SUCCESS,
  payload
});

export default (project) => async (dispatch, getState) => {

  dispatch(deleteProjectOfferDocumentRequest());
  const query = odata({ service: getServiceUrl() }).resource(RESOURCES.Projects, project.ID).resource(RESOURCES.OfferDocument).resource(RESOURCES.Ref);
  const errorOrResult = await query.delete({
    headers: {
      Authorization: `Bearer ${getState().user.token}`,
      ...getDefaultHeader()
    }
  })
    .then(resp => resp)
    .then(res => {
      const ok = res.statusCode <= 299 && res.statusCode >= 200;
      if (res.statusCode === 500) {
        const errorKey = "GENERAL_SERVER_ERROR";
        return new Error(errorKey);
      } else if (!ok) {
        console.log('delete offer document api error', res.toJSON());
        const body = JSON.parse(res.body);
        const { Error: { Message } } = body
        const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
        return new Error(errorKey);
      } else {
        return project;
      }
    })

  if (errorOrResult instanceof Error) {
    dispatch(deleteProjectOfferDocumentError(errorOrResult, DELETE_PROJECT_OFFER_DOCUMENT_ERROR));
    console.log("CODE ERROR: ", errorOrResult.message);
    if (errorOrResult.message.split(":")[0] === "401") {
      dispatch(tokenExpired());
      dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
    }
    dispatch(showNotification(errorOrResult.message.split(",")[1], "error"))
    return errorOrResult;
  } else {
    dispatch(showNotification("SUCCESSFUL_DELETE_OFFER_DOCUMENT", "success"))
  }

  dispatch(deleteProjectOfferDocumentSuccess(errorOrResult));

  return errorOrResult;
};